import React, { useId } from "react";

import { cn } from "@/lib/chillnn/cn";

import AddPhotoAlternativeIcon from "@/components/ui/icon/add-photo";

type Props = {
	isDragging: boolean;
	handleDragEnter: (e: React.DragEvent<HTMLLabelElement>) => void;
	handleDragLeave: (e: React.DragEvent<HTMLLabelElement>) => void;
	handleDragOver: (e: React.DragEvent<HTMLLabelElement>) => void;
	handleDrop: (e: React.DragEvent<HTMLLabelElement>) => void;
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
} & React.RefAttributes<HTMLInputElement>;

export const InputForm = React.forwardRef<HTMLInputElement, Props>(
	({ isDragging, handleDragEnter, handleDragLeave, handleDragOver, handleDrop, handleChange }, ref) => {
		const id = useId();

		return (
			<div className="relative w-full">
				<label
					htmlFor={id}
					className={cn(
						"z-10 block h-32 w-full max-w-[350px] rounded border border-zinc-200 p-4 hover:cursor-pointer", //
						isDragging && "bg-zinc-300/40",
					)}
					onDragEnter={handleDragEnter}
					onDragLeave={handleDragLeave}
					onDragOver={handleDragOver}
					onDrop={handleDrop}
				>
					<div className="flex h-full w-full items-center justify-center text-zinc-500">
						<div className="flex flex-col gap-y-4">
							<div className="grid place-content-center">
								<AddPhotoAlternativeIcon className="h-10 w-10 text-zinc-500" />
							</div>
							<div className="flex flex-col gap-y-2">
								<p className="text-xs">クリックまたはドラッグ&ドロップで画像をアップロード</p>
								<p className="text-xs">
									<strong className="tracking-widest">jpg / jpeg / png / gif</strong> に対応しています
								</p>
							</div>
						</div>
					</div>
					<input
						type="file"
						accept="image/png, image/jpeg, image/jpg, image/gif"
						id={id}
						ref={ref}
						value=""
						onChange={handleChange}
						className="sr-only"
					/>
				</label>
			</div>
		);
	},
);

InputForm.displayName = "InputForm";
